<template>
  <div class="retailOrderPay" >
    <XR-head titleText="订单支付" :rightShow="false" ref="headObj"></XR-head>

    <div class="price-info" v-if="!loaded">
      <div class="row">
        <p class="title">需支付</p>
        <p class="price">
          <i class="fa fa-rmb"></i>
          <span>{{totalMoney.toFixed(2)}}</span>
        </p>
      </div>
    </div>

    <mu-list class="payWay" v-if="!loaded">
      <mu-sub-header>支付方式</mu-sub-header>
      <mu-divider/>
      <!-- <mu-list-item title="金币支付" @click="choosePayWay('coin')">
        <mu-icon value=":fa fa-money6" class="payWayCoinIcon" slot="left"/>
        <mu-radio name="group" nativeValue="coin" v-model="payWayValue" class="demo-radio" slot="right"/>
      </mu-list-item>
      <mu-divider inset/> -->
      <mu-list-item title="支付宝" @click="choosePayWay('alipay')">
        <mu-icon value=":fa fa-alipay" class="payWayAlipayIcon" slot="left"/>
        <mu-radio name="group" nativeValue="alipay" v-model="payWayValue" class="demo-radio" slot="right"/>
      </mu-list-item>
      <mu-divider inset/>
      <mu-list-item title="微信支付" @click="choosePayWay('wechat')" v-if="openId || AppID">
        <mu-icon value=":fa fa-wechat" class="payWayWechatIcon" slot="left"/>
        <mu-radio name="group" nativeValue="wechat" v-model="payWayValue" class="demo-radio" slot="right"/>
      </mu-list-item>
    </mu-list>

    <mu-divider />
    <div class="bottom-bar" v-if="!loaded">
      <mu-row >
        <mu-col width="65" tablet="65" desktop="65">
          <p class="cart-total">
            <span>实付款：<i class="fa fa-rmb"></i></span>
            <span class="money">{{totalMoney.toFixed(2)}}</span>
          </p>
        </mu-col>
        <mu-col width="35" tablet="35" desktop="35">
          <mu-flat-button :label="btnText" @click="goPay()" class="gobuy" backgroundColor="red" color="white" fullWidth />
        </mu-col>
      </mu-row>
    </div>
    <mu-dialog :open="dialog" title="请输入支付密码" @close="closeDialog">
      <mu-text-field hintText="支付密码" type="password" v-model="payPassword" v-if="safeInfo.IsMpass" />
      <router-link :to="'/usercenter/payPassword?redirect_url='+localUrl" v-if="!safeInfo.IsMpass">尚未设置支付密码，点击设置</router-link>
      <mu-flat-button slot="actions" @click="payNo" primary label="取消"/>
      <mu-flat-button slot="actions" primary @click="payYes" label="确定"/>
    </mu-dialog>
    <XR-toast :is-show='isShow' ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import md5 from 'js-md5'
export default {
  data () {
    return {
      cartItemProductInfoWidth: (parseInt(document.documentElement.clientWidth)-130),
      addressInfoWidth: (parseInt(document.documentElement.clientWidth)-70) ,
      chooseInfoWidth: (parseInt(document.documentElement.clientWidth)-190) ,      
      payWayValue: 'alipay',
      btnText : '支付宝',
      dialog : false,
      WUAPrice : '',
      isShow : 'none',
      orderNos:this.$route.query.orderNo.split(','),
      loaded: true,
      totalMoney:0,
      payPassword:'' ,
      safeInfo:{
        IsMpass:false
      } ,
      localUrl: encodeURIComponent(window.location.href),
      openId:'',
	  randNum :Math.random(),
	  AppID:''
    }
  },
  mounted(){
    this.$refs.XRtoast.load()
    this.getUserSafe()
    this.getPayInfo()

    this.openId = this.$store.state.wechat.WeChatInfo
	if (window.localStorage.AppID){
		this.AppID = window.localStorage.AppID;
	}
  },
  methods: {
    getUserSafe(){      
      var ths = this
      ths.$post(
        "/Shop/UserServer/GetUserSafeInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.safeInfo = res.Data
          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    getPayInfo(){
      var ths = this
      ths.$post(
        "/Shop/PurchaseServer/GetOrderPayingInfoByOrderNos",
        JSON.stringify({orderNos:this.orderNos})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.totalMoney = res.Data.TotalMoney
          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    open (obj) {
      this[obj+'Popup'] = true
    },
    close (obj) {
      this[obj+'Popup'] = false
    },
    openDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    },
    payYes () {
      this.dialog = false
      
      if(!this.safeInfo.IsMpass){
        this.$router.push('/usercenter/payPassword?redirect_url='+ this.localUrl)
      }

      var ths = this
      ths.payPassword = md5(ths.payPassword)
      if(ths.payWayValue == "coin"){
        ths.$post(
          "/Shop/PurchaseServer/OrderCoinPay",
          JSON.stringify({orderNos:this.orderNos, payPassword:this.payPassword})
        ).then(function(res) {
          if(!res.IsSuccess){
            //ths.$router.push("/wholesale/orderpayfailed?content="+ res.Msg)
            ths.payPassword = ''
            ths.$refs.XRtoast.failed(res.Msg, true)
          }else{  
            ths.$router.push("/wholesale/orderpaysuccess")
          }
        });
      }
      else if(ths.payWayValue == 'sun'){
        ths.$post(
          "/Shop/PurchaseServer/OrderSunPay",
          JSON.stringify({orderNos:this.orderNos, payPassword:this.payPassword})
        ).then(function(res) {
          if(!res.IsSuccess){
            //ths.$router.push("/wholesale/orderpayfailed?content="+ res.Msg)
            ths.payPassword = ''
            ths.$refs.XRtoast.failed(res.Msg, true)
          }else{  
            ths.$router.push("/wholesale/orderpaysuccess")
          }
        });
      }
    },    
    payNo () {
      this.dialog = false
      this.$refs.XRtoast.show('您取消了支付')      
    },
    goPay(){
      if(this.payWayValue == 'coin'){
        this.openDialog()
      }
      else if(this.payWayValue == 'wua'){
        this.openDialog()
      }
      else if(this.payWayValue == 'sun'){
        this.openDialog()
      }
      else if(this.payWayValue == 'alipay'){
        window.location.href= this.MOBILE_URL + "/pay/alipay/pay.aspx?rnd="+this.randNum+"&orderNo="+this.$route.query.orderNo+"&type=5&redirect_url="+ this.localUrl
      }
      else if(this.payWayValue == 'wechat'){
        //this.$router.push('/oauth/wechat/getUserInfo')
        window.location.href= this.MOBILE_URL + "/pay/wechat/weipay.aspx?rnd="+this.randNum+"&AppID="+this.AppID+"&openId="+this.openId+"&orderNo="+this.$route.query.orderNo+"&type=5&redirect_url="+ this.localUrl
      }
      else{
        this.btnText = '请选择'
      }
    },
    choosePayWay(val){
      this.payWayValue = val
    }
  },
  watch :{
    isFapiao:function(){
      if(this.isFapiao){
        this.open('fapiao')
      }
    },
    isIntegral:function(){
      if(this.isIntegral){
        this.open('integral')
      }
    },
    payWayValue : function(){      
      this.WUAPrice = ''
      if(this.payWayValue == 'coin'){
        this.btnText = '金币支付'
      }
      else if(this.payWayValue == 'wua'){
        this.btnText = 'WUA支付'
        //this.WUAPrice = '611WUA'
      }
      else if(this.payWayValue == 'sun'){
        this.btnText = 'SUN支付'
        //this.WUAPrice = '611WUA'
      }
      else if(this.payWayValue == 'alipay'){
        this.btnText = '支付宝支付'
      }
      else if(this.payWayValue == 'wechat'){
        this.btnText = '微信支付'
      }
      else{
        this.btnText = '请选择'
      }
    }
  }
}
</script>
<style>
.retailOrderPay{
  background: #F0F2F5;
}


.retailOrderPay .price-info{
  background: white;
  padding:10px;
}
.retailOrderPay .price-info .row{
  background: white;
  overflow: hidden;
  line-height: 32px;
}
.retailOrderPay .price-info .row .title{
  font-size: 14px;
  font-weight: 700;
}
.retailOrderPay .price-info .row .price{
  color:Red;
  font-weight: 700;
}


.retailOrderPay .payWay{
  margin-top: 10px;
  background: white;
}
.retailOrderPay .payWay .wuaPrice{
  color:red;
}
.retailOrderPay .payWay .payWayCoinIcon{
  color:#F2CB0A;
}
.retailOrderPay .payWay .payWayWuaIcon{
  color:#F29509;
}
.retailOrderPay .payWay .payWayAlipayIcon{
  color:#00A0E9;
}
.retailOrderPay .payWay .payWayWechatIcon{
  color:#7ED53D;
}


.retailOrderPay .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  height: 56px;
  border-top:1px solid #eee;
}
.retailOrderPay .bottom-bar .cart-total{
  float: left;
  height: 56px;
  line-height: 56px;
  padding-left: 20px;
  font-size: 16px;
  font-weight: 700;
  color:Red;
}
.retailOrderPay .gobuy{
  width: 100%;
  line-height: 56px;
  height: 56px;
  text-align: center;
  font-size: 12px;
}

.retailOrderPay-popupLayer {
  width: 100%;
  min-height: 120px;
}
.retailOrderPay-popupLayer .deliveryChoose {
  padding: 0 20px;
}
.retailOrderPay-popupLayer .delvieryChooseBtn{
  margin: 40px 0 0;
  height: 50px; 
}
</style>



// WEBPACK FOOTER //
// src/pages/wholesale/orderPay.vue